import angular from 'angular';

BusinessHoursParamsController.$inject = ['$scope', 'SiteFilterHelperFactory',  'company', 'sites', 'BusinessHoursFactory', 'AlertingFactory', 'UserFactory', 'businessHoursConfig', 'TopToolbarFactory'];
export function BusinessHoursParamsController($scope, SiteFilterHelperFactory, company, sites,  BusinessHoursFactory, AlertingFactory, UserFactory, businessHoursConfig, TopToolbarFactory) {


  $scope.save = save;
  $scope.enableSave = enableSave;
  $scope.comaSeparatedTeamsNames = comaSeparatedTeamsNames;
  $scope.copyCurrentToAllTeams = copyCurrentToAllTeams;
  $scope.copyCurrentToAllSites = copyCurrentToAllSites;

  init();

  function save() {
    BusinessHoursFactory.updateBusinessHours(company.id, businessHoursConfig)
      .then(() => {
          AlertingFactory.success('account/business-hours/updated/ok');
          disableSave();
        },  
        AlertingFactory.httpErrorHandler());
  }

  function enableSave() {
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function disableSave() {
    TopToolbarFactory.updateButtonDisable(true, $scope);
  }

  function copyCurrentToAllSites() {
    const configs = businessHoursConfig.for_sites;
    const sourceConfig = configs[$scope.filteredSiteId];
    sites.forEach(site => configs[site.id] = {
                        'timezone': sourceConfig.timezone,
                        'week': angular.copy(sourceConfig.week),
                        'exceptions': angular.copy(sourceConfig.exceptions)
                      });
    AlertingFactory.success('parameters/bh/by_team/copy_confirm');
    enableSave();
  }

  function comaSeparatedTeamsNames() {
    return $scope.routingTags.map(tag => tag.name).join(', ');
  }

  function copyCurrentToAllTeams() {
    const configs = businessHoursConfig.for_routing_tags;
    const sourceConfig = configs[$scope.filters.routingTag.id];
    $scope.routingTags.forEach(tag => configs[tag.id] = {
                        'timezone': sourceConfig.timezone,
                        'week': angular.copy(sourceConfig.week),
                        'exceptions': angular.copy(sourceConfig.exceptions)
                      });
    AlertingFactory.success('parameters/bh/by_team/copy_confirm');
    enableSave();
  }
  

  function routingTagSelected(tag) {
    // Routing tags by team are not intialized by default in the backend
    if (!businessHoursConfig.for_routing_tags[tag.id]) {
      businessHoursConfig.for_routing_tags[tag.id] = {
        'timezone': UserFactory.defaultTimeZone(),
        'week': [],
        'exceptions': []
      }
    }
    $scope.configs.forSelectedTeam = businessHoursConfig.for_routing_tags[tag.id];
  }

  function init() {
    TopToolbarFactory.setTitleTranslation('account/business-hours/title', $scope);
    TopToolbarFactory.setButton('save', save, $scope);

    $scope.configs = {
      'forSelectedSite': {},
      'forSelectedTeam': {}
    }
    $scope.filters = {
      // The site-filter helper uses $scope.filteredSiteId
      'routingTag': null // but we need a subobject for the routing tag, as the tab's ng-if creates a child scope
    }

    // Init by-site tab
    const localStorageKey = 'bh-site-id-for-company-' + company.id;
    const higherPriorityinitialValue = null;
    const hasAllSitesItem = false;
    SiteFilterHelperFactory.initScope($scope, sites, localStorageKey, higherPriorityinitialValue, hasAllSitesItem);
    $scope.$watch("filteredSiteId", (newSiteId) => {
      $scope.configs.forSelectedSite = businessHoursConfig.for_sites[newSiteId];
    });

    // Init by-team tab
    if (hasRoutingTag(company)) {
        $scope.routingTags = routingTagsExceptNoneValue(company);
        if ($scope.routingTags.length === 0) {
            $scope.hasRoutingTag = false;
        } else {
            $scope.filters.routingTag = $scope.routingTags[0];
            $scope.$watch("filters.routingTag", (newTag) => {
                routingTagSelected(newTag);
            });
            $scope.hasRoutingTag = true;
        }
    } else {
      $scope.hasRoutingTag = false;
    }

    disableSave();
  }

}

// Helper functions
function hasRoutingTag(company) {
  return !!company.tags_groups.find(tg => tg.is_routing === 1);
}
function routingTagsExceptNoneValue(company) {
  const routingTagGroup = company.tags_groups.find(tg => tg.is_routing === 1);
  const noneValueId = routingTagGroup.none_tag.id;
  return routingTagGroup.tags_and_categories.filter(tag => tag.id !== noneValueId && !tag.is_category);
}
